import { Button } from '@bbpos/ui';

// ─── Design tokens ──────────────────────────────────────────────────────────
const GLASS_PANEL =
  'rounded-2xl bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm shadow-[0_12px_30px_-18px_rgba(15,23,42,0.22)] dark:shadow-[0_12px_30px_-18px_rgba(0,0,0,0.5)]';

interface TenantProvisionBannerProps {
  onProvision: () => void;
  onReject: () => void;
  loading?: boolean;
  /** ADMIN+ only — provision and reject are @Roles('ADMIN') on the API. */
  canApprove: boolean;
}

export function TenantProvisionBanner({
  onProvision,
  onReject,
  loading,
  canApprove,
}: TenantProvisionBannerProps) {
  return (
    <div className={`${GLASS_PANEL} relative overflow-hidden mb-6 animate-slide-up`}>
      {/* Gradient accent bar */}
      <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-amber-500/18 to-amber-500/0" />

      <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-5">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">
              Awaiting Approval
            </p>
            <p className="mt-0.5 text-sm text-neutral-500 dark:text-neutral-400">
              This tenant is awaiting approval. Review the details and click Approve &amp; Provision to activate.
            </p>
            {!canApprove && (
              <p className="mt-1 text-xs font-medium text-amber-700 dark:text-amber-400">
                An Admin approves new businesses.
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <Button variant="danger" size="sm" onClick={onReject} disabled={loading || !canApprove}>
            Reject
          </Button>
          <Button variant="primary" size="sm" onClick={onProvision} loading={loading} disabled={!canApprove}>
            Approve &amp; Provision
          </Button>
        </div>
      </div>
    </div>
  );
}
